import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Table from '../../../Table';
// import TableRow from '../../TableRow';
// import TableCell from '../../TableCell';

import { TableSkeletonProps } from './TableSkeleton.types';

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns = 2,
  rows = 3,
  textSize = 90,
  highlightColumn = 0,
  highlightRow = 0,
  className
}) => {
  return (
    <Table showHeader={false} className={className}>
      <>
        {/* {Array(rows)
          .fill(0)
          .map((_el, ind) => (
            <TableRow
              key={`row-${ind}`}
              className={
                highlightRow > 0 && ind === highlightRow - 1
                  ? 'secondary-background'
                  : ''
              }
            >
              {Array(columns)
                .fill(0)
                .map((_ele, index) => (
                  <TableCell
                    key={`col-${index}`}
                    className={
                      highlightColumn > 0 && index === highlightColumn - 1
                        ? 'secondary-background'
                        : ''
                    }
                  >
                    <Skeleton
                      variant="rect"
                      width={textSize}
                      height={16}
                      className="mx2 my4"
                    />
                  </TableCell>
                ))}
            </TableRow>
          ))} */}
      </>
    </Table>
  );
};

export default TableSkeleton;
export { TableSkeletonProps };
